<template>
  <div von-loading class="loading-container" :class="{'visible': state == 1, 'visible active': state == 2}">
    <div class="loading">
      <div v-if="showSpinner" class="spinner spinner-ios">
        <svg viewBox="0 0 64 64">
          <g stroke-width="4" stroke-linecap="round"><line y1="17" y2="29" transform="translate(32,32) rotate(180)"><animate attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(210)"><animate attributeName="stroke-opacity" dur="750ms" values="0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(240)"><animate attributeName="stroke-opacity" dur="750ms" values=".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(270)"><animate attributeName="stroke-opacity" dur="750ms" values=".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(300)"><animate attributeName="stroke-opacity" dur="750ms" values=".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(330)"><animate attributeName="stroke-opacity" dur="750ms" values=".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(0)"><animate attributeName="stroke-opacity" dur="750ms" values=".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(30)"><animate attributeName="stroke-opacity" dur="750ms" values=".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(60)"><animate attributeName="stroke-opacity" dur="750ms" values=".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(90)"><animate attributeName="stroke-opacity" dur="750ms" values=".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(120)"><animate attributeName="stroke-opacity" dur="750ms" values=".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(150)"><animate attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1" repeatCount="indefinite"></animate></line></g></svg>
      </div>

      <span v-if="tips" class="tips" v-html="tips"></span>
    </div>
  </div>
</template>
<style lang='scss'>
  .loading-container {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 115;
    display: -webkit-box;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -moz-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -moz-align-items: center;
    align-items: center;
    -webkit-transition: opacity .2s linear;
    transition: opacity .2s linear;
    visibility: hidden;
    opacity: 0;

    &.visible {
      visibility: visible;
    }

    &.active {
      opacity: 1;
    }

    .loading {
      padding: 12px 24px !important;
      border-radius: 3px;
      background-color: rgba(255, 255, 255, 0.95);
      color: #000;
      text-align: center;
      text-overflow: ellipsis;
      font-size: 15px;
    }

    .spinner {
      margin-bottom: 6px;
      padding-top: 2px;
    }

    .spinner.spinner-ios {
      width: 100%;
      height: 21px;
    }

    .spinner svg {
      width: 21px !important;
      height: 21px !important;
      stroke: #000;
      fill: #000;
    }

    .tips {
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      letter-spacing: -0.3px;
      font-family: "PingFangSC-Semibold", $font-stack;
    }
  }
</style>
<script>
  const removeElement = (marker) => {
    let el = document.querySelector(marker) || document.querySelector(`[${marker}]`)
    if (el) {
      document.body.removeChild(el)
    }
  }

  function preventDefault (e) {
    e.preventDefault()
  }

  export default {
    data () {
      return {
        state: 0,
        tips: '',
        showSpinner: true
      }
    },

    destroyed () {
      console.log('[Vonic] Loading _vm destroyed')
      removeElement('von-loading')
    },

    methods: {
      show (options) {
        this.tips = options.tips
        this.showSpinner = !!options.showSpinner

        this.state = 1
        setTimeout(() => {
          this.state = 2
        })

        document.body.addEventListener('touchmove', preventDefault)
      },

      hide () {
        this.state = 1
        setTimeout(() => {
          this.state = 0
          setTimeout(() => {
            this.$destroy()
          })
        }, 300)

        document.body.removeEventListener('touchmove', preventDefault)
      },

      update (options) {
        this.tips = options.tips
        this.showSpinner = !!options.showSpinner
      },

      getState () {
        return this.state
      }
    }
  }
</script>
